import { formatText } from '@ltvco/refresh-lib/v2';

interface RenderMessageContentProps {
  text: string | null;
}

export const MessageContentRenderer = ({ text }: RenderMessageContentProps) => {
  // Handle null or empty text
  if (!text) {
    return null;
  }

  const processedText = formatText(text);
  const lines = processedText.split('\n');

  return lines.map((line, lineIndex) => {
    // Only process bold formatting if it exists in the line
    if (!line.includes('**')) {
      return (
        <span key={lineIndex}>
          {line}
          {lineIndex < lines.length - 1 && <br />}
        </span>
      );
    }

    // Improved regex: match **text** patterns, avoiding greedy matching
    // This handles cases like: "**bold1** normal **bold2**"
    const parts = line.split(/(\*\*(?:(?!\*\*).)+\*\*)/g);
    const parsedParts = parts.map((part, partIndex) => {
      if (part.startsWith('**') && part.endsWith('**') && part.length > 4) {
        return <b key={`${lineIndex}-${partIndex}`}>{part.slice(2, -2)}</b>;
      }
      return part;
    });

    return (
      <span key={lineIndex}>
        {parsedParts}
        {lineIndex < lines.length - 1 && <br />}
      </span>
    );
  });
};
